// plugins/vuex.ts
import { defineNuxtPlugin } from '#app'
import { createVuexStore } from '@/store'

export default defineNuxtPlugin((nuxtApp) => {
  const store = createVuexStore()
  nuxtApp.vueApp.use(store)
  // opcional: exposición por si la necesitas fuera de setup
  nuxtApp.provide('store', store) // => nuxtApp.$store
})
